module.exports = __webpack_public_path__ + "index_pc/img/img_default_photo.f5e52201.png";